import { jsx as _jsx } from "react/jsx-runtime";
import { faThumbsUp as faThumbsUpFilled } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, IconButton } from '@mui/material';
var VotingIconButton = function (_a) {
    var voteCount = _a.voteCount, votedOn = _a.votedOn, onClick = _a.onClick;
    return (_jsx(Badge, { badgeContent: voteCount, color: 'primary', anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, children: _jsx(IconButton, { onClick: onClick, sx: {
                '&:hover': {
                    backgroundColor: 'transparent', // Remove hover background
                },
            }, children: _jsx(FontAwesomeIcon, { style: { fontSize: '0.9em' }, icon: votedOn == true ? faThumbsUpFilled : faThumbsUp }) }) }));
};
export default VotingIconButton;
